var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',{staticClass:"p1"},[_vm._v("提交成功，审核中")]),_vm._m(0),_c('img',{staticClass:"smt-ewm",attrs:{"src":_vm.$store.state.static_img_url + 'pic/apply/ewm3.png'}}),_c('a',[_vm._v(_vm._s(_vm.wait)+"s后返回上一页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"p2"},[_vm._v("在此期间如有任何疑问"),_c('br'),_vm._v("可以扫描二维码添加在线客服咨询")])
}]

export { render, staticRenderFns }